import { device } from '@/utils/index'

const content = [
    // 第一章 第一节 Lead-in
    // 章标题
    {
        key: 'section1',
        type: "title",
        category: 1, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: "第<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>章", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        // text: '文旌数字教材', // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/chapterImage.png"), // 标题图片
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/top_bg.png") // 背景图片  默认：无
        }
    },
    // 小标题
    {
        key: 'section1.0',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Lead-in", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/title-back.png"),
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },

    },
    // 模板样式 单个带边框
    {
        key: 'section1.1',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            backgroundColor: '#FFFFFF'
                // paddingTop: 0,
                // paddingBottom: 0,
                // borderRadius: 0,
                // border: '',
                // borderTop: '',
                // borderBottom: ''
        },
        content: [{
                key: 'section1.1.0',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'I',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    }
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.1.0.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.1.0.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Match the pictures and the customs with the corresponding  traditional Chinese festivals. And then talk about how people celebrate these festivals.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            {
                // 交互 排一排
                key: 'section1.1.1', // *必填* 唯一标识
                type: 'action', // *必填* 类型：交互
                actionType: 2, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                styleType: 2, // 样式类型 actionType = 2 时 1：默认示例中样式 2：英语中样式，拖拽字母
                showTitle: 2, // 是否展示题目 1：默认是 2：否
                title: '', // 标题
                isExample: 1,
                isInBlock: 1,
                titleStyle: {},
                content: {
                    // 排一排
                    key: 'action6',
                    sortData: [{
                            key: 'action6.1.1',
                            actionKey: 'action6',
                            cover: require("@/assets/images/books/book2/action/sort-icon-1.png"),
                            answerKey: 1,
                            width: 210,
                            height: 225,
                        },
                        {
                            key: 'action6.1.2',
                            actionKey: 'action6',
                            cover: require("@/assets/images/books/book2/action/sort-icon-2.png"),
                            answerKey: 4,
                            width: 210,
                            height: 225,
                        },
                        {
                            key: 'action6.1.3',
                            actionKey: 'action6',
                            cover: require("@/assets/images/books/book2/action/sort-icon-3.png"),
                            answerKey: 3,
                            width: 210,
                            height: 225,
                        },
                        {
                            key: 'action6.1.4',
                            actionKey: 'action6',
                            cover: require("@/assets/images/books/book2/action/sort-icon-4.png"),
                            answerKey: 2,
                            width: 210,
                            height: 225,
                        },
                        {
                            key: 'action6.1.5',
                            actionKey: 'action6',
                            cover: require("@/assets/images/books/book2/action/sort-icon-5.png"),
                            answerKey: 5,
                            width: 210,
                            height: 225,
                        },
                    ],
                    answerData: [{
                            key: 'action6.2.1',
                            actionKey: 'action6',
                            answerKey: 1,
                            answerLable: "A",
                            text: 'the Mid-Autumn Festival',
                            pdfUrl: require("@/assets/pdf/book2/pdf-1.pdf")
                        },
                        {
                            key: 'action6.2.2',
                            actionKey: 'action6',
                            answerKey: 2,
                            answerLable: "B",
                            text: 'the Spring Festival',
                            pdfUrl: require("@/assets/pdf/book2/pdf-2.pdf")
                        },
                        {
                            key: 'action6.2.3',
                            actionKey: 'action6',
                            answerKey: 3,
                            answerLable: "C",
                            text: 'the Lantern Festival',
                            pdfUrl: require("@/assets/pdf/book2/pdf-3.pdf")
                        },
                        {
                            key: 'action6.2.4',
                            actionKey: 'action6',
                            answerKey: 4,
                            answerLable: "D",
                            text: 'the Dragon Boat Festival',
                            pdfUrl: require("@/assets/pdf/book2/pdf-4.pdf")
                        },
                        {
                            key: 'action6.2.5',
                            actionKey: 'action6',
                            answerKey: 5,
                            answerLable: "E",
                            text: 'the Double Ninth Festival',
                            pdfUrl: require("@/assets/pdf/book2/pdf-5.pdf")
                        },
                    ],
                },
            }
        ],
    },
    // 模板样式 单个带边框
    {
        key: 'section1.2',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 30,
            marginBottom: 30,
            padding: 0,
            backgroundColor: '#FFFFFF'
                // paddingBottom: 0,
                // borderRadius: 0,
                // border: '',
                // borderTop: '',
                // borderBottom: ''
        },
        content: [{
                key: 'section1.2.0',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'II',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section1.2.0.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section1.2.0.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Watch the video and discuss the following questions with your partner.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                    paddingLeft: 20,
                    paddingRight: 20,
                }
            },
            
            // 视频
            {
                key: 'section1.2.1.0', // *必填* 唯一标识
                type: 'video', // *必填* 类型：视频
                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                playerInline: 1, // 是否是行内播放 1：行内播放
                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                content: [ // *必填* 视频列表
                    {
                        key: 'section1.2.1.1.1', // *必填* 唯一标识
                        url: require("@/assets/video/book2/1-2视频.mp4"), // *必填* 视频地址
                        left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                        title: '1-2视频', // 视频标题
                        subtitle: '1-2视频', // 视频副标题 只在全部显示时使用
                        titleStyle: {
                            // 根据需要是否加标题样式
                            // fontFamily: 'xxx', // 字体，本地配置的字体
                            // fontSize: 20, // 文字大小  默认：20
                            // lineHeight: 40, // 行高  默认：36
                            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            padding: 20,
                            paddingTop: 0,
                            paddingBottom: 0,
                        }
                    },
                ],
            },
            //展开收起title
            {
                key: 'section1.2.2',
                type: 'template',
                category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    // padding: 0,
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                title: 'Click here for subtitle',
                titleStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    // padding: 0,
                    // paddingTop: 0,
                    // paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
                content: [{
                        key: 'section1.2.2.1', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.1.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Yunnan is the most ethnically diverse province in China. A traditional festival is a chance for the different ethnic groups to learn about each other. One of the most famous events is the Dai people’s Water-Sprinkling Festival. Today, they’re welcoming visitors from all over the country to join in the celebrations. The locals built this square just for this reason.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            marginTop: 20,
                        },
                    },
                    {
                        key: 'section1.2.2.2', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.2.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '云南是全国世居少数民族最多的省份。每个民族的传统节日往往是各民族人民互相了解的绝佳途径。最具盛名的传统节日之一就是傣族的泼水节。今天，他们正以最大的热情，欢迎来自全国各地与他们一起欢庆的人们。当地人专门修建了这个广场，让水把祝福带给大家。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.3', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.3.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'However, for the natives, the real battleground is by the Lancang River, where it’s a no-holds-barred water fight. The fighting has spread to the streets. Civilians have taken up kitchen utensils against the authorities who are armed with sprinkling trucks. In this joyous combat, getting soaked from head to toe is a sign of victory.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.4', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.4.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '然而，对景洪本地人来说，“主战场”在澜沧江的江边。你来我往，毫不相让。街道深处，游击战、遭遇战、狙击战各自展开。来自锅碗瓢盆的民间配送，是“弹药”补给，用来与官方的酒水车正规军“作战”。欢乐的大战中，成为湿透的“落汤鸡”才是最大的赢家。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.5', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.5.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'On the grassland, the grandest festival is still Naadam Festival. Just as in nature where animals sometimes scatter and then sometimes gather, the people of the grassland use this time to come together.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.6', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.6.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '在草原上，最盛大的节日仍然是那达慕节。就像自然界中的动物时聚时散一样，草原上的人们会利用这个节日欢聚在一起。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.7', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.7.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'During Naadam Festival, one can watch skillful tailors showing off their skills. Veteran craftsmen display their rare saddle workmanship. Perhaps the most popular craft to observe is the Mongolian ladies rolling and making felts. Layers of wool are pressed tightly together. Felts made in this way is very warm and thick. It’s the primary material used by Mongolians to build yurts which resist wind, rain, and snow so well.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.8', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.8.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '在那达慕节期间，人们可以观看技艺高超的裁缝展示他们的手艺。经验丰富的匠人会展示他们非凡的马鞍工艺，而围观人气最高的可能就是蒙古女性卷毡制毡的手艺了。一层层羊毛被紧紧地压在一起，用这种方法制作的毛毡非常暖和厚实。羊毛毡是蒙古人用来建造蒙古包的主要材料，可以很好地遮风挡雨、防雪保暖。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.9', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.9.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Batar’s four sons and her Ji Ri Ga La has also come. He’s a great wrestler. Mongolian wrestling doesn’t classify by age, weight, or rank, and winner is decided as soon as one falls. Only the person that keeps winning to the end can win the championship. Another Naadam’s most exciting event, however, can win the championship. This exciting scene takes the people who live here back to the time when they roamed, and conquered, throned, experiencing the honor of their ancestors.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.10', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.10.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '巴特尔的四个儿子和她的吉日嘎拉也来了。他是一名出色的摔跤手。蒙古摔跤不分年龄、体重和级别，一跤定胜负。只有一直赢到最后的人，才能获得冠军。节日中另一项最刺激的活动是赛马。这一激动人心的场面将生活在这里的人们带回了那个他们在马背上打天下、叱咤风云的时代，重温先祖的荣耀。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.11', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.11.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'Welcome to Harbin. And welcome to the Ice and Snow World. Ice and Snow World Festival is the city’s main spectacle. Covering over 800,000 square meters, it’s the biggest such event in the world and draws people from all corners of the globe.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.12', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.12.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '欢迎来到哈尔滨。欢迎来到冰雪大世界。国际冰雪节是这座城市的一大盛景。占地面积超过80万平方米，哈尔滨国际冰雪节是世界上最大的冰雪盛会，吸引了来自世界各地的游客。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.13', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.13.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'I’m from Germany.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.14', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.14.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '我来自德国。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.15', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.15.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'I’m from Russia.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.16', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.16.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '我来自俄罗斯。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.17', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.17.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'I’m from Argentina.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.18', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.18.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '我来自阿根廷。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.19', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.19.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'The Ice and Snow World is famous for its intricate giant sculptures carved entirely from ice and snow. Over 250,000 cubic meters of ice is used. The ice architecture, while spectacular, isn’t the only thing to behold. The giant slides are the cherries on top, with many queuing up to six hours for a chance to ride.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.20', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.20.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '冰雪大世界以完全由冰雪雕刻而成的巨型复杂雕塑而闻名，使用的冰块超过25万立方米。冰雪建筑虽然壮观，但并不是唯一的看点。超级冰滑梯是最精彩的项目，许多人排队6个小时才能滑一次。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.21', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.21.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: 'The winter festival isn’t just limited to the park, it spreads to several locations across Harbin. Zhong Yang Da Jie, or Central Street, is one of the longest pedestrian streets in China. And it’s at this 125-year-old street that you really get a feel of the city’s Russian influence as well as Heilongjiang’s proximity to the Chinese-Russian border. It batches European-style buildings, and many of the shops have both Chinese and Russian signage. The street is also a major point of one of the city’s most interesting winter traditions.', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Calibri', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                            lineHeight: 40, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            // color: '#111', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                        },
                    },
                    {
                        key: 'section1.2.2.22', // *必填* 唯一标识
                        type: 'text', // *必填* 类型：正文
                        isInTable: true,
                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            {
                                key: 'section1.2.2.22.1', // *必填* 唯一标识
                                category: 'text', // *必填* 内容类型 text：文本
                                text: '哈尔滨国际冰雪节并不局限于冰雪大世界，还包括哈尔滨的多个地方。中央大街是中国最长的步行街之一，正是在这条有着125年历史的街道上，你才能真正感受到这座城市的俄罗斯风情，切身体会到黑龙江毗邻中俄边境的地理位置。中央大街上有许多欧式建筑，许多商店都有中俄两种文字的招牌。中央大街也是这个城市在冬天最有趣的主要传统景点之一。', // *必填* 文本内容
                                textStyle: {},
                            },
                        ],
                        textStyle: {
                            fontFamily: 'Microsoft YaHei', // 字体，本地配置的字体
                            fontSize: device.isMobile ? 26 : 22, // 文字大小  默认：20
                            lineHeight: 36, // 行高  默认：36
                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                            color: '#333', // 文本颜色  默认：#00a8ac
                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                            marginBottom: 20,
                        },
                    },
                ],
                contentStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                    // marginTop: 30,
                    // marginBottom: 30,
                    padding: 20,
                    paddingTop: 0,
                    paddingBottom: 0,
                    // borderRadius: 0,
                    // border: '',
                    // borderTop: '',
                    // borderBottom: ''
                },
            },
            // 答题
            {
                key: 'section1.2.3.0', // *必填* 唯一标识
                type: 'question', // *必填* 类型：答题
                onlyContent: 1, // 只存在内容
                submitBtnStyle: { //按钮的样式
                    width: 180,
                    height: 52,
                    lineHeight: 52, // 行高  默认：46
                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                },
                content: [{
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">1 <\/span>Have you ever heard of or celebrated these festivals? Which festival in the video interests you the most?<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    },
                    {
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">2 <\/span>Are there any interesting festivals in your hometown? How will you celebrate them?<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    },
                    {
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">3 <\/span>Do you know any other interesting festivals in China or around the world? How do people celebrate them?<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    },
                    {
                        "topic_id": 57,
                        "id": 57,
                        "type_id": 4,
                        "typenm": "简答题",
                        "shorttag": "",
                        "showway": "",
                        "topic_score": "8.00",
                        "isauto": 0,
                        "info": "",
                        "km": "",
                        "stem_url": "",
                        "audiofile": "",
                        "audiofile_suffix": "",
                        "audiofile_title": "附件下载",
                        "is_collect": 0,
                        "status": 0,
                        "is_play": 0,
                        "issign": 0,
                        "isok": 0,
                        "isdone": 0,
                        "getscore": 0,
                        "comment": "",
                        "ischeck": 0,
                        "ps_info": "根据相关要求，完成下列题目。",
                        "topic_sub": [{
                            "shorttag": "",
                            "direction": 0,
                            "type_id": 4,
                            "typenm": "简答题",
                            "score": "8.00",
                            "topic_id": 57,
                            "sub_id": 1,
                            "isauto": 0,
                            "is_upload": 0,
                            "para44_id": 0,
                            "upload_explain": "",
                            "options": [],
                            "showway": "",
                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">4 <\/span>What can you gain from celebrating festivals? Why do people celebrate festivals in your opinion?<\/span><\/p>",
                            "subanalysis": "",
                            "sortid": 1,
                            "file_name": "",
                            "user_answer": [],
                            "brief_answer": {},
                            "user_status": -1,
                            "answer_img": {},
                            "topic_answer": [{
                                "topic_id": 57,
                                "sub_id": 1,
                                "sortid": 1,
                                "ask": "",
                                "answer": "",
                                "askend": null,
                                "answer_id": 1,
                                "answer_url": "",
                                "answertitle": null,
                                "score": "8.00",
                                "operation_score": 0
                            }],
                            "video_list": [],
                            "isok": 0,
                            "isdone": 0,
                            "concat_answer": "",
                            "user_concat_answer": ""
                        }]
                    },
                ],
                completeType: '', // 答题完成后的操作 statistics：展示统计结果
            },
        ],
    },
]
export default content
